const Dates = ({ date }) => {
  return (
    <span className="relative flex text-bodyMobile lg:text-subheadingCardsMobile xl:text-subheadingCardsDesktop font-chivoMono text-background">
      {date}
    </span>
  )
}

export default Dates
